import React, { Component } from 'react';
import screenfull from 'screenfull';
import ReactPlayer from 'react-player';
import axios from 'axios';

import Sidebar from '../../components/sidebar';
import Menu from '../../components/menu';

const playerConfig = {
  vimeo: {
    playerOptions: {
      title: true,
      byline: true,
      color: 'fff'
    }
  }
}

class Videos extends Component {
  constructor() {
    super()

    this.state = {
      sidebarHidden: true,
      fullscreen: false,
      data: [],
    }

    this.toggleSidebar = this.toggleSidebar.bind(this)
    this.toggleFullscreen = this.toggleFullscreen.bind(this)
  }

  componentDidMount() {
    document.body.classList.toggle('is-works');

    this.loadWorks()
  }

  componentWillUnmount() {
    document.body.classList.remove('is-works');
  }

  loadWorks(id) {
    const url = "/data/videos.json";

    axios.get(url)
      .then((r) => {
        this.setState({
          data: r.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  toggleSidebar() {
    this.setState((prevState) => ({
      sidebarHidden: !prevState.sidebarHidden
    }));
  }

  toggleFullscreen() {
    screenfull.toggle()

    this.setState((prevState) => ({
      fullscreen: !prevState.fullscreen
    }))
  }

  renderNavbar() {
    return (
      <div className="navbar">
        <a onClick={this.toggleSidebar} className="navbar__link navbar__link--toggler">
          <i className="icon icon--menu"></i>
        </a>
        <a onClick={this.toggleFullscreen} className="navbar__link navbar__link--fullscreen">
          <i className="icon icon--fullscreen"></i>
        </a>
      </div>
    )
  }

  renderVideos() {
    const { data } = this.state;

    const items = data.map(video => (
      <div key={video.name} className="videos__item">
        <ReactPlayer url={video.url} controls={true} config={playerConfig} />
      </div>
    ));

    return (
      <div className="videos">
        { items }
      </div>
    );
  }

  render() {
    const { sidebarHidden } = this.state;

    return (
      <div className="page">
        { this.renderNavbar() }

        <Sidebar hidden={sidebarHidden}>
          <Menu modifier="sidebar" intro={true} handleOnClick={this.toggleSidebar} />
        </Sidebar>

        { this.renderVideos() }
      </div>
    )
  }
};

export default Videos;



// WEBPACK FOOTER //
// ./src/views/videos/index.js